/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

// require('./bootstrap');


window.Vue = require('vue').default;

import BootstrapVue from 'bootstrap-vue' //Importing
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)
/** Axios */
const axios = require('axios');
const csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
const prefixPanel = document.querySelector('meta[name="prefix-panel"]').getAttribute('content')
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['X-CSRF-TOKEN'] = csrf;
Vue.prototype.$axios = axios;
Vue.prototype.$prefixPanel = prefixPanel;

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faPlus, faUser, faArrowLeft, faEdit, faPrint, faEllipsisV, faCog, faTimesCircle, faTrashAlt, faCalendar, faEuroSign, faDollarSign, faMoneyBillWave, faCommentDollar, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'
const moment = require('moment')
require('moment/locale/es')
 
Vue.use(require('vue-moment'), {
    moment
})
 
import { MazPhoneNumberInput } from 'maz-ui'
Vue.use(MazPhoneNumberInput)


/** Vuex */
import Vuex from 'vuex'
Vue.use(Vuex)
import storeQuote from "./store/Quote"

const store = new Vuex.Store({
    modules: {
        quote:storeQuote
    }
})
library.add(faPlus, faUser, faArrowLeft, faEdit, faPrint, faEllipsisV, faCog, faTimesCircle, faTrashAlt, faCalendar, faEuroSign, faDollarSign, faMoneyBillWave, faCommentDollar, faExternalLinkAlt)
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);
// Vue.component('test', require('./components/Test.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
    components:{
        FontAwesomeIcon
    },
    store
});
